(function(){
  "use strict";
  var CFG=(typeof window!=='undefined'&&window.EE_QUIZFV_CFG)||{};
  var CDN='https://cdn.shopify.com/s/files/1/0541/4499/1401/files/';
  function pick(k,d){ return (CFG[k]!==undefined&&CFG[k]!=='')?CFG[k]:d; }

  // ---- product catalog (URLs / prices / images editable in Shopify settings) ----
  var PRODUCTS={
    fv:{name:'Fruits & Veggies',price:pick('fv_price','from $46.95'),img:pick('fv_img',CDN+'Bottle_Front.webp'),url:pick('fv_url','/pages/fruits-and-veggies-alternative'),
        why:'A simple floor under the days your plate falls short — 11 whole-food fruits & veggies in just 2 daily capsules.',
        pts:['11 whole-food fruits & veggies, 4 USDA Organic','No proprietary blends — every amount on the label','2 capsules a day, nothing to mix'],
        how:'Take 2 capsules daily, most people with breakfast.'},
    colostrum:{name:'Colostrum',price:pick('col_price','from $54.95'),img:pick('col_img',CDN+'Bottle_Front.webp'),url:pick('col_url','/pages/colostrum-v2'),
        why:'Gentle daily support for gut and everyday resilience — clean, pasture-raised colostrum without the hype.',
        pts:['Pasture-raised, Grade A colostrum','Unflavored or Chocolate','One simple scoop a day'],
        how:'Stir one scoop into cold water or a smoothie, once a day.'},
    electrolytes:{name:'Electrolytes',price:pick('el_price','from $39.95'),img:pick('el_img',CDN+'Bottle_Front.webp'),url:pick('el_url','/pages/electrolytes-hydration'),
        why:'Clean hydration for active days and travel — real minerals, no dyes, no sugar crash.',
        pts:['Balanced sodium, potassium & magnesium','No sugar, no artificial dyes','Mixes clear in water'],
        how:'Mix one stick into 16–20 oz of water, once a day or after activity.'},
    bundle:{name:'Daily Foundation Bundle',price:pick('bundle_price','save vs. buying separately'),img:pick('bundle_img',CDN+'Bottle_Front.webp'),url:pick('bundle_url','/pages/fruits-and-veggies-alternative'),
        why:'The simple daily base — whole-food nutrition plus gut support — bundled so it costs less than buying separately.',
        pts:['Fruits & Veggies + Colostrum','One easy daily routine','Subscribe and save more'],
        how:'2 capsules of Fruits & Veggies + 1 scoop of Colostrum each morning.'}
  };

  // ---- questions ----
  var QUESTIONS=[
    {id:'goal',eyebrow:'Your goal',title:"What are you most focused on right now?",help:'Pick the one that fits best.',
     opts:[
      {v:'daily',em:'🥕',b:'Daily nutrition',s:"I don't eat enough fruits & veggies"},
      {v:'gut',em:'🌿',b:'Gut & everyday resilience',s:'Support how I feel day to day'},
      {v:'hydration',em:'💧',b:'Hydration',s:'Active days, travel, feeling depleted'},
      {v:'aging',em:'🌤️',b:'Healthy aging',s:'Stay capable and steady over time'},
      {v:'energy',em:'⚡',b:'Energy & vitality',s:'Feel more alive through the day'},
      {v:'unsure',em:'🤔',b:"Not sure yet",s:'Point me in the right direction'}
     ]},
    {id:'veg',eyebrow:'Real talk',title:"Honestly, how often do you eat 5+ servings of veg?",help:"No judgment — about 9 in 10 adults fall short. It just helps us recommend well.",
     opts:[
      {v:'rare',em:'🍟',b:'Rarely',s:'Vegetables barely make the plate'},
      {v:'some',em:'🥗',b:'A few times a week',s:'I try, but it slips'},
      {v:'most',em:'🥦',b:'Most days',s:'Usually pretty good'},
      {v:'daily',em:'🌈',b:'Every day',s:'I eat the rainbow'}
     ]},
    {id:'format',eyebrow:'Your routine',title:"What format do you prefer?",help:'The best routine is the one you actually keep.',
     opts:[
      {v:'caps',em:'💊',b:'Capsules',s:'Nothing to mix or taste'},
      {v:'powder',em:'🥤',b:'Powder / drink',s:'I like a scoop in water'},
      {v:'fewest',em:'✅',b:'As few steps as possible',s:'Keep it simple'},
      {v:'nopref',em:'🤷',b:'No preference',s:'Whatever works best'}
     ]},
    {id:'current',eyebrow:'Where you are',title:"What's your current supplement routine?",help:'This helps us not pile on.',
     opts:[
      {v:'none',em:'🆕',b:'None right now',s:'Starting fresh'},
      {v:'few',em:'✌️',b:'One or two products',s:'A light routine'},
      {v:'many',em:'📦',b:'Honestly, too many',s:'I want to simplify'},
      {v:'simplify',em:'🧹',b:'I want to simplify',s:'Fewer, better things'}
     ]},
    {id:'buy',eyebrow:'Last one',title:"How would you like to start?",help:'We’ll tailor the offer to match.',
     opts:[
      {v:'one',em:'🎯',b:'Try one product first',s:'Keep it low commitment'},
      {v:'bundle',em:'🧺',b:'Build a simple bundle',s:'Cover the daily base'},
      {v:'subscribe',em:'🔁',b:'Subscribe if it saves money',s:'Set it and forget it'},
      {v:'learn',em:'📖',b:'I want to learn more first',s:'Send me the guide'}
     ]}
  ];

  var state={idx:0,answers:{},email:''};
  var screens={};
  document.querySelectorAll('.screen').forEach(function(s){screens[s.dataset.screen]=s;});
  var qScreen=screens.q, progressUI=document.getElementById('progressUI'),
      bar=document.getElementById('bar'), plbl=document.getElementById('plbl'),
      backBtn=document.getElementById('backBtn');

  function dl(ev,data){ try{ window.dataLayer=window.dataLayer||[]; window.dataLayer.push(Object.assign({event:ev},data||{})); }catch(e){} }

  function show(name){
    Object.keys(screens).forEach(function(k){screens[k].classList.toggle('active',k===name);});
    window.scrollTo({top:0,behavior:'smooth'});
  }

  function updateProgress(){
    var total=QUESTIONS.length;
    var step=Math.min(state.idx+1,total);
    bar.style.width=(step/total*100)+'%';
    plbl.textContent=step+' / '+total;
    backBtn.classList.toggle('show',state.idx>0);
  }

  function renderQuestion(){
    var q=QUESTIONS[state.idx];
    progressUI.style.display='block';
    updateProgress();
    var html='<span class="eyebrow q-eyebrow">'+q.eyebrow+'</span>'+
             '<h2 class="q-title">'+q.title+'</h2>'+
             '<p class="q-help">'+q.help+'</p><div class="opts">';
    q.opts.forEach(function(o){
      var sel=state.answers[q.id]===o.v?' sel':'';
      html+='<button class="opt'+sel+'" data-v="'+o.v+'"><span class="em">'+o.em+'</span>'+
            '<span class="tx"><b>'+o.b+'</b><span>'+o.s+'</span></span><span class="rd"></span></button>';
    });
    html+='</div>';
    qScreen.innerHTML=html;
    show('q');
    qScreen.querySelectorAll('.opt').forEach(function(btn){
      btn.addEventListener('click',function(){
        state.answers[q.id]=btn.dataset.v;
        qScreen.querySelectorAll('.opt').forEach(function(b){b.classList.remove('sel');});
        btn.classList.add('sel');
        dl('quiz_question_answered',{question:q.id,answer:btn.dataset.v,step:state.idx+1});
        setTimeout(next,240);
      });
    });
  }

  function next(){
    if(state.idx<QUESTIONS.length-1){ state.idx++; renderQuestion(); }
    else { progressUI.style.display='none'; show('email'); }
  }
  backBtn.addEventListener('click',function(){
    if(state.idx>0){ state.idx--; renderQuestion(); }
  });

  document.getElementById('startBtn').addEventListener('click',function(){
    dl('quiz_start'); state.idx=0; renderQuestion();
  });

  // email step
  document.getElementById('emailNext').addEventListener('click',function(){
    var v=document.getElementById('emailInput').value.trim();
    if(v && /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)){ state.email=v; dl('quiz_email_submit',{email_provided:true}); }
    else if(v){ document.getElementById('emailInput').focus(); return; }
    finish();
  });
  document.getElementById('emailSkip').addEventListener('click',function(){ dl('quiz_email_submit',{email_provided:false}); finish(); });

  function finish(){
    show('loading');
    dl('quiz_complete',{answers:state.answers,email_provided:!!state.email});
    setTimeout(renderResults,1100);
  }

  // ---- recommendation logic ----
  function recommend(a){
    var goalMap={daily:['fv','colostrum'],gut:['colostrum','fv'],hydration:['electrolytes','fv'],
                 aging:['colostrum','fv'],energy:['fv','electrolytes'],unsure:['fv','colostrum']};
    var pair=(goalMap[a.goal]||['fv','colostrum']).slice();
    // Funnel intent: low veg intake pushes Fruits & Veggies to primary
    if((a.veg==='rare'||a.veg==='some') && pair[0]!=='fv'){
      pair=['fv', pair[0]];
    }
    // Format preference nudges (powder-leaning goals)
    if(a.format==='powder' && pair[0]==='fv' && (a.goal==='hydration')){ pair=['electrolytes','fv']; }
    // Purchase preference: bundle
    var primary=pair[0], secondary=pair[1];
    if(a.buy==='bundle'){ primary='bundle'; secondary=pair[0]==='fv'?'colostrum':'fv'; }
    return {primary:primary,secondary:secondary};
  }

  function renderResults(){
    var rec=recommend(state.answers);
    var P=PRODUCTS[rec.primary], S=PRODUCTS[rec.secondary];
    var subLabel = state.answers.buy==='subscribe' ? ' · subscribe & save' : '';
    var quizNote = (state.answers.veg==='rare'||state.answers.veg==='some')
      ? "Based on your answers — especially how often veggies actually make your plate — here's the simplest place to start."
      : "Based on your goals and routine, here's the simplest place to start.";
    var html=''+
     '<div class="res-head"><span class="eyebrow">Your daily ritual</span>'+
       '<h2>We’d start you with <em>'+P.name+'</em></h2></div>'+
     '<div class="res-card"><div class="top">'+
       '<div class="media"><img src="'+P.img+'" alt="'+P.name+'"></div>'+
       '<div class="body">'+
         '<span class="pill">Best match</span>'+
         '<h3>'+P.name+'</h3>'+
         '<div class="price">'+P.price+subLabel+'</div>'+
         '<p class="why">'+P.why+'</p>'+
         '<ul class="mini">'+P.pts.map(function(p){return '<li><span class="ck">✓</span><span>'+p+'</span></li>';}).join('')+'</ul>'+
         '<div class="cta-row">'+
           '<a class="btn btn-primary" href="'+P.url+'" data-rec="'+rec.primary+'">Shop '+P.name+'</a>'+
         '</div>'+
       '</div>'+
     '</div></div>'+
     '<p class="res-note"><b>How to use:</b> '+P.how+'</p>'+
     '<p class="res-note">'+quizNote+' Remember: supplements are a floor, not a replacement for real food.</p>'+
     '<div class="sec-rec">'+
       '<div class="thumb"><img src="'+S.img+'" alt="'+S.name+'"></div>'+
       '<div class="info"><div class="lbl">You might also like</div><h4>'+S.name+'</h4><p>'+S.price+'</p></div>'+
       '<a class="go" href="'+S.url+'" data-rec="'+rec.secondary+'">View →</a>'+
     '</div>'+
     '<div class="res-links">'+
       '<a href="'+pick('edu_url','/pages/eat-your-vegetables')+'">Read: if you don’t eat your veggies</a>'+
       '<a href="'+pick('compare_url','/pages/fruits-and-veggies-alternative')+'">Compare Fruits & Veggies</a>'+
     '</div>'+
     '<button class="restart" id="restartBtn">↺ Retake the quiz</button>';
    document.getElementById('resultsBody').innerHTML=html;
    show('results');
    dl('quiz_result_view',{primary:rec.primary,secondary:rec.secondary});
    document.querySelectorAll('#resultsBody a[data-rec]').forEach(function(a){
      a.addEventListener('click',function(){ dl('quiz_product_click',{product:a.dataset.rec}); });
    });
    document.getElementById('restartBtn').addEventListener('click',function(){
      state={idx:0,answers:{},email:''}; progressUI.style.display='none'; show('welcome');
    });
  }
})();